import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

const resourcePage = {
    department: "English",
    short: "english",
    programmePath: "/programme/bsh/english",
    description:
        "Access student resources for the Department of English including syllabus, timetable, academic calendar, language lab materials, question papers, add-on courses, publications, and mentor details.",
    sections: [
        {
            title: "IA Syllabus",
            items: [
                {
                    label: "IA Coverage",
                    href: "https://drive.google.com/file/d/1nv7jsd4BepFeiYRkGXYq4eZu28jX3ALK/view?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Timetable",
        //     items: [{ label: "English Timetable", href: "#" }],
        // },
        {
            title: "Academic Calendar",
            items: [
                {
                    label: "Calendar of Events",
                    href: "https://drive.google.com/file/d/1daygHO3VhNlNC8R3OGDOehTbisW1KMN7/view?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Lab Manuals",
        //     items: [{ label: "English Language Lab Manual", href: "#" }],
        // },
        {
            title: "Question Papers & Solutions",
            items: [{ label: "English Question Papers and Solutions", href: "#" }],
        },
        // {
        //     title: "Add-On Subjects",
        //     items: [{ label: "English Add-On Course Syllabus", href: "#" }],
        // },
        // {
        //     title: "Published Papers & Patents",
        //     items: [{ label: "English Published Papers / Patents", href: "#" }],
        // },
        {
            title: "Mentor List",
            items: [
                {
                    label: "Mentor List 2025-26",
                    href: "https://drive.google.com/file/d/1IfRQUtCD2p59R2Zf945kqLVnx3usvTu1/view?usp=drive_link"
                }
            ],
        },
    ],
};

const EnglishResources = () => (
    <StudentResourceTemplate resourcePage={resourcePage} />
);

export default EnglishResources;
